import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminDashboard = () => {
  const { auth } = useAuth();
  
  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col>
          <h1>Admin Dashboard</h1>
          <p className="lead">Welcome, {auth?.user?.role} user. You have access to all sections of the application.</p>
        </Col>
      </Row>
      
      <Row className="mb-5">
        <Col md={4} className="mb-3">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>CRNA / Provider Management</Card.Title>
              <Card.Text>
                Manage provider profiles, credentials, and job preferences.
              </Card.Text>
              <Link to="/profile">
                <Button variant="primary">Provider Dashboard</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={4} className="mb-3">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Group / Facility Management</Card.Title>
              <Card.Text>
                Manage group profiles, facilities, and staffing requirements.
              </Card.Text>
              <Link to="/group-intake">
                <Button variant="primary">Group Dashboard</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={4} className="mb-3">
          <Card className="h-100">
            <Card.Body>
              <Card.Title>Listings Review</Card.Title>
              <Card.Text>
                Review and manage job listings from all facilities.
              </Card.Text>
              <Link to="/listings/review">
                <Button variant="primary">Review Listings</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <Row className="mb-4">
        <Col>
          <h2>Quick Access</h2>
        </Col>
      </Row>
      
      <Row>
        <Col md={3} className="mb-3">
          <Card className="text-center h-100">
            <Card.Body>
              <Card.Title>Facility Waitlist</Card.Title>
              <Link to="/facility-waitlist">
                <Button variant="outline-primary">Access</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={3} className="mb-3">
          <Card className="text-center h-100">
            <Card.Body>
              <Card.Title>RSVP Management</Card.Title>
              <Link to="/rsvp">
                <Button variant="outline-primary">Access</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={3} className="mb-3">
          <Card className="text-center h-100">
            <Card.Body>
              <Card.Title>User Management</Card.Title>
              <Link to="/admin/users">
                <Button variant="outline-primary">Access</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={3} className="mb-3">
          <Card className="text-center h-100">
            <Card.Body>
              <Card.Title>System Settings</Card.Title>
              <Link to="/admin/settings">
                <Button variant="outline-primary">Access</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
